import { render, staticRenderFns } from "./LmFormSeparator.vue?vue&type=template&id=5d20246a&scoped=true&"
import script from "./LmFormSeparator.vue?vue&type=script&lang=js&"
export * from "./LmFormSeparator.vue?vue&type=script&lang=js&"
import style0 from "./LmFormSeparator.vue?vue&type=style&index=0&id=5d20246a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20246a",
  null
  
)

export default component.exports